import { JobContentLink } from '@doda/common/src/logics/JobContent/createJobContentLink';

import { createSlice } from '@reduxjs/toolkit';

/**
 * ジョブコンテンツページリンク情報
 * @param jobContentLink ジョブコンテンツページリンク情報
 */
export interface InitialStateType {
  jobContentLink: JobContentLink[];
}

/**
 * ジョブコンテンツページリンク初期値
 * @param jobContentLink ジョブコンテンツページリンク情報
 */
export const jobContentLinkInitialState: InitialStateType = {
  jobContentLink: [],
};

/**
 * ジョブコンテンツページリンクスライス
 * @param jobContentLink ジョブコンテンツページリンク情報
 */
export const jobContentLinkSlice = createSlice({
  name: 'jobContentLink',
  initialState: jobContentLinkInitialState,
  reducers: {
    setJobContentLink: (state, action) => {
      state.jobContentLink = action.payload;
    },
  },
});

// Create Action
export const { setJobContentLink } = jobContentLinkSlice.actions;

// reducer
export const jobContentLinkReducer = jobContentLinkSlice.reducer;

interface State {
  jobContentLink: InitialStateType;
}

/**
 * 初期表示判定フラグSelector
 * @param state
 * @returns ジョブコンテンツページリンク情報
 */
export const jobContentLinkSelector = <S extends State>(state: S) =>
  state.jobContentLink;
